import { useState } from "react";
import { useSelector } from "react-redux";
import { Form, Row, Col } from "react-bootstrap";
import DialogFooter from "./DialogFooter.js";
import { buildDashboardModule, buildDashboardPayload } from "./dashboardPayloadConstants.js";

const CreateHelpNeededView = ({
  initialSettings,
  onHide,
  isUpdateMode = false,
  helpNeededCount,
  reloadDashboard,
  toastRef,
}) => {
  const { userInformation } = useSelector((state) => state.UserReducer);
  const [submitting, setSubmitting] = useState(false);
  // From options
  const defaultFromOptions = [
    { label: "My Tasks", value: "My Tasks", checked: false },
    { label: "My Projects", value: "My Projects", checked: false },
    { label: "All Projects", value: "All Projects", checked: false },
  ];
  const initialFrom =
    initialSettings?.From?.split(",")
      .map((f) => f.trim())
      .filter(Boolean) || [];
  const [fromOptions, setFromOptions] = useState(
    defaultFromOptions.map((opt) => ({
      ...opt,
      checked: initialFrom.includes(opt.value),
    })),
  );

  const handleCheckboxChange = (index) => {
    const updated = [...fromOptions];
    updated[index].checked = !updated[index].checked;
    setFromOptions(updated);
  };

  const buildDashboardHelpNeededPayload = () => {
    const getChecked = (options) =>
      options
        .filter((opt) => opt.checked)
        .map((opt) => opt.value.trim())
        .join(",");
    const userId = initialSettings?.User_ID || userInformation?.userid;
    let moduleName;
    if (isUpdateMode) {
      moduleName = initialSettings?.Title;
    } else {
      const count =
        typeof helpNeededCount === "number" && !isNaN(helpNeededCount) ? helpNeededCount : 0;
      moduleName = `HelpNeeded_${count + 1}`;
    }
    const module = buildDashboardModule({
      moduleId: isUpdateMode ? initialSettings?.Module_ID || "" : "",
      moduleName: moduleName,
      moduleType: "Helpneeded",
      userId,
      config: {
        From: getChecked(fromOptions),
      },
      Sequence: isUpdateMode ? initialSettings?.Sequence : -1
    });
    return buildDashboardPayload({ module });
  };

  const handleCreateOrUpdate = async () => {
    setSubmitting(true);
    const payload = buildDashboardHelpNeededPayload();
    try {
      const { createOrUpdateDashboardModuleView } = await import("../../../apis/dashboardApi.js");
      await createOrUpdateDashboardModuleView(payload);
      if (toastRef && toastRef.current) {
        toastRef.current.show({
          severity: "success",
          summary: "Success",
          detail: isUpdateMode
            ? "Help Needed module updated successfully"
            : "Help Needed module created successfully",
          life: 3000,
        });
      }
      if (typeof reloadDashboard === "function") reloadDashboard();
      onHide();
    } catch (err) {
      if (toastRef && toastRef.current) {
        toastRef.current.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to create/update Help Needed module.",
          life: 5000,
        });
      }
      console.error("Error creating/updating Help Needed module:", err);
      setSubmitting(false);
    }
  };

  const isFormValid = fromOptions.some((option) => option.checked);

  return (
    <>
      <div style={{ background: "#f6f8fa", borderRadius: 8, padding: 24 }}>
        <Row className="helpneeded-form">
          <Col md={6}>
            <Form.Group>
              <Form.Label className="mb-2 module-form-label">
                From <span className="mandatory-asterisk"> *</span>
              </Form.Label>
              <div className="d-flex flex-column gap-2 ms-3">
                {fromOptions.map((option, index) => (
                  <Form.Check
                    key={option.value}
                    type="checkbox"
                    id={`from-${option.value}`}
                    label={option.label}
                    checked={option.checked}
                    onChange={() => handleCheckboxChange(index)}
                  />
                ))}
              </div>
            </Form.Group>
          </Col>
        </Row>
      </div>
      <DialogFooter
        submitting={submitting}
        isFormValid={isFormValid}
        isUpdateMode={isUpdateMode}
        onCancel={onHide}
        onSubmit={handleCreateOrUpdate}
      />
    </>
  );
};

export default CreateHelpNeededView;
